import React, { useState, useEffect } from "react";
import imageAlejandria from "../../components/assets/Alejandria-Logo.png";
import FirstQuestionFormComponent from "./firstQuestion";
import FourthQuestionFormComponent from "./fourthQuestion";
import FormMinorDataComponent from "./minorData";
import SecondQuestionFormComponent from "./secondQuestion";
import ThirdQuestionFormComponent from "./thirdQuestion";
import { useSearchParams } from "react-router-dom";
import { getTokenValidation, setPatientFormData } from "../../api/api";

const FormAppointmentComponent = () => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [responseConfirmData, setResponseConfirmData] = useState({});
  const [infoPatient, setInfoPatient] = useState({
    id: "",
    name: "",
    address: "",
    city: "",
    phoneNumber: "",
    profession: "",
    dni: "",
    postalCode: "",
    province: "",
    email: "",
    birthdate: "",
    countryCode: "ES",
    gender: "",
  });
  const [questions, setQuestions] = useState({
    q1: { response: "", observations: "" },
    q2: { response: "", observations: "" },
    q3: { response: "", observations: "" },
    q4: { response: "", observations: "" },
    q5: { response: "", observations: "" },
    q6: { response: "", observations: "" },
    q7: { response: "", observations: "" },
  });
  const [responsibleMinorData, setResponsibleMinorData] = useState({
    name: "",
    address: "",
    city: "",
    dni: "",
    postalCode: "",
    province: "",
  });

  const [searchParams] = useSearchParams();
  let token = searchParams.get("k");

  useEffect(() => {
    token && getTokenValidation(token, onResponse, onError);
  }, []);

  const onResponse = (response) => {
    const parseResponse = JSON.parse(response);
    setInfoPatient((prevInfo) => ({
      ...prevInfo,
      id: parseResponse.patient.id,
      name: parseResponse.patient.name,
      dni: parseResponse.patient.dni,
      email: parseResponse.patient.email,
      phoneNumber: parseResponse.patient.phoneNumber,
    }));
  };

  const onError = (error) => {
    alert(error);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const onResponseSendData = (response) => {
    setResponseConfirmData(JSON.parse(response));
    setShowConfirmationModal(true);
  };

  const sendData = () => {
    setPatientFormData(
      infoPatient,
      questions,
      responsibleMinorData,
      token,
      onResponseSendData,
      onError
    );
  };

  const onClickModalConfirm = () => {
    setShowConfirmationModal(false);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const onClickModalError = () => {
    setShowErrorModal(false);
  };

  const questionResponse = (response) => {
    setCurrentQuestion(response);
  };

  const onChangeQuestions = (updatedValue, question) => {
    setQuestions((prevInfo) => ({
      ...prevInfo,
      [question]: updatedValue[question],
    }));
  };

  const onChangeResponsibleMinorData = (updatedValue) => {
    setResponsibleMinorData((prevInfo) => ({
      ...prevInfo,
      name: updatedValue.name,
      address: updatedValue.address,
      city: updatedValue.city,
      dni: updatedValue.dni,
      postalCode: updatedValue.postalCode,
      province: updatedValue.province,
    }));
  };

  const onChangeInfoPatient = (updatedValue) => {
    setInfoPatient((prevInfo) => ({
      ...prevInfo,
      name: updatedValue.name,
      address: updatedValue.address,
      city: updatedValue.city,
      phoneNumber: updatedValue.phoneNumber,
      profession: updatedValue.profession,
      dni: updatedValue.dni,
      postalCode: updatedValue.postalCode,
      province: updatedValue.province,
      email: updatedValue.email,
      birthdate: updatedValue.birthdate,
      countryCode: updatedValue.countryCode,
      gender: updatedValue.gender,
    }));
  };

  const renderCurrentQuestion = () => {
    switch (currentQuestion) {
      case 1:
        return (
          <FirstQuestionFormComponent
            infoPatient={infoPatient}
            onChangeInfoPatient={onChangeInfoPatient}
            questionResponse={questionResponse}
            setShowErrorModal={setShowErrorModal}
            token={token}
          />
        );
      case 2:
        return (
          <SecondQuestionFormComponent
            questionResponse={questionResponse}
            questions={questions}
            onChangeQuestions={onChangeQuestions}
            setShowErrorModal={setShowErrorModal}
          />
        );
      case 3:
        return (
          <ThirdQuestionFormComponent
            questionResponse={questionResponse}
            questions={questions}
            onChangeQuestions={onChangeQuestions}
            setShowErrorModal={setShowErrorModal}
          />
        );
      case 4:
        return (
          <FourthQuestionFormComponent
            questions={questions}
            onChangeQuestions={onChangeQuestions}
            sendData={sendData}
            setShowErrorModal={setShowErrorModal}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="appointmentContainer">
      <img className="imageAlejandria" src={imageAlejandria} />
      {currentQuestion === 5 ? (
        <FormMinorDataComponent
          questionResponse={questionResponse}
          responsibleMinorData={responsibleMinorData}
          onChangeResponsibleMinorData={onChangeResponsibleMinorData}
          setShowErrorModal={setShowErrorModal}
        />
      ) : (
        <div className="newAppointmentNewPatient">
          <div className="appointmentButtons">
            <button
              className="buttonOption"
              onClick={() => questionResponse(1)}
            >
              1
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 2 ? "active" : ""}`}
              style={currentQuestion >= 2 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => questionResponse(2)}
              disabled={currentQuestion !== 2 && currentQuestion <= 2}
            >
              2
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 3 ? "active" : ""}`}
              style={currentQuestion >= 3 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => questionResponse(3)}
              disabled={currentQuestion !== 3 && currentQuestion <= 3}
            >
              3
            </button>
            <div
              className={`lineButtons ${currentQuestion >= 4 ? "active" : ""}`}
              style={currentQuestion >= 4 ? { background: "#676563" } : null}
            />
            <button
              className="buttonOption"
              onClick={() => questionResponse(4)}
              disabled={currentQuestion !== 4 && currentQuestion <= 4}
            >
              4
            </button>
          </div>
          {renderCurrentQuestion()}
        </div>
      )}
      {showErrorModal && (
        <div className="errorModal">
          <div className="errorModalContent">
            <h2 className="titleErrorModal">Upps!!</h2>
            <p className="contentErrorModal">Faltan datos por completar</p>
            <button className="btnErrorModal" onClick={onClickModalError}>
              Cerrar
            </button>
          </div>
        </div>
      )}
      {showConfirmationModal && (
        <div className="errorModal">
          <div className="errorModalContent">
            <h2 className="titleErrorModal">Confirmación</h2>
            <p className="contentErrorModal">{responseConfirmData.message}</p>
            <button className="btnErrorModal" onClick={onClickModalConfirm}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormAppointmentComponent;
